import { Registry } from '@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform';
import { ClientExtensions } from '../constants';
import { URI } from '@vscode-alt/monaco-editor/esm/vs/base/common/uri';
import { IEditorInputFactoryRegistry, IEditorInputFactory } from '@workbench-stack/core';
import { interfaces } from 'inversify';


class EditorInputFactoryRegistry implements IEditorInputFactoryRegistry {

    private fileInputFactory;
    private readonly editorInputFactoryInstances: { [editorInputId: string]: IEditorInputFactory } = Object.create(null);

    // public start(container: interfaces.Container): void {

    //     for (let key in this.editor){
    //         const element = this.editorINpu[];
    //         this.createEditorInputFactory(key, element);
    //     }
    // }
    private createEditorInputFactory(editorInputId: string, editorInputFactory: IEditorInputFactory) {
        if (this.editorInputFactoryInstances[editorInputId]) {
            console.warn(`EditorInputFactory instance of ${editorInputId} will be replaced by new factory`);
        }
        this.editorInputFactoryInstances[editorInputId] = editorInputFactory;
    }
    public registerFileInputFactory(factory): void {
        this.fileInputFactory = factory;
    }

    public getFileInputFactory() {
        return this.fileInputFactory;
    }

    public registerEditorInputFactory(editorInputId: string, editorInputFactory: IEditorInputFactory): void {
        this.createEditorInputFactory(editorInputId, editorInputFactory);
    }

    public getEditorInputFactory(editorInputId: string): IEditorInputFactory {
        return this.editorInputFactoryInstances[editorInputId];
    }

    public hasEditorInput(resource: URI) {
        const scheme = resource.scheme;
        return !!this.editorInputFactoryInstances[scheme];
    }

    public getEditorInput(resource: URI, label: string | undefined, encoding: string | undefined, mode: string | undefined, container: interfaces.Container | undefined, additionalProps: object | undefined) {

        // search by entire URI
        let element = this.editorInputFactoryInstances[resource.toString()];
        if (!element) {
            // if not search by scheme and authority
            element = this.editorInputFactoryInstances[`${resource.scheme}/${resource.authority}`];
            if (!element) {
                // we can further narrow down with the help of `query` in URI.
                const scheme = resource.scheme;
                element = this.editorInputFactoryInstances[scheme];
            }
        }
        return element.createInput(resource, label, encoding, mode, container, additionalProps);
    }
}

Registry.add(ClientExtensions.EditorInputFactories, new EditorInputFactoryRegistry());
